export type SortableRegistrationCategory = {
  categoryGender?: string | null;
  categoryKey?: string | null;
  categoryName?: string | null;
};

const CATEGORY_GENDER_ORDER: Record<string, number> = {
  female: 0,
  male: 1,
  mixed: 2,
  open: 3,
};

const categoryNameCollator = new Intl.Collator("pt-BR", {
  sensitivity: "base",
  numeric: true,
});

export function compareRegistrationCategories(
  left: SortableRegistrationCategory,
  right: SortableRegistrationCategory,
) {
  const leftGender = String(left.categoryGender || "")
    .trim()
    .toLowerCase();
  const rightGender = String(right.categoryGender || "")
    .trim()
    .toLowerCase();
  const genderDifference =
    (CATEGORY_GENDER_ORDER[leftGender] ?? 4) -
    (CATEGORY_GENDER_ORDER[rightGender] ?? 4);
  if (genderDifference !== 0) return genderDifference;

  const nameDifference = categoryNameCollator.compare(
    String(left.categoryName || "").trim(),
    String(right.categoryName || "").trim(),
  );
  if (nameDifference !== 0) return nameDifference;

  return categoryNameCollator.compare(
    String(left.categoryKey || "").trim(),
    String(right.categoryKey || "").trim(),
  );
}

export function sortRegistrationCategories<
  T extends SortableRegistrationCategory,
>(categories: readonly T[]) {
  return [...categories].sort(compareRegistrationCategories);
}
